import { useCallback, useRef, useState } from 'react'

import { RaidMarkerType } from 'app/frontend/types/custom/RaidMarker'

const useCastNoteDraft = () => {
  const [draft, setDraft] = useState('')
  const inputRef = useRef<HTMLInputElement>(null)

  const insertMarker = useCallback((marker: RaidMarkerType) => {
    const token = `{${marker}}`
    setDraft((current) => `${current}${current.length ? ' ' : ''}${token}`)
  }, [])

  return {
    draft,
    setDraft,
    inputRef,
    insertMarker,
  }
}

export default useCastNoteDraft
